// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"3362":"e5267965cb9bb7da9c24","6888":"52fa7a6273ca4cec5ced"}[chunkId] + ".js";
};